import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsyncSubject, BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { api_base_url } from '../../api/api_url';
import { scaleImg } from '../../helpers/scale_img';
import { Categoria } from '../../interfaces/custom/categoria';
import { Famiglia } from '../../interfaces/custom/famiglia';
import { Link } from '../../interfaces/link';
import { NavigationLink } from '../../interfaces/navigation-link';
import { StoreService } from '../store.service';
import { AccountService } from './account.service';
import { ServizioMenuService } from '../servizio-menu.service';

@Injectable({
  providedIn: 'root'
})

export class CategoriaAttualeService {
  currentCategory$: BehaviorSubject<string>;
  currentCategoryChanged$: BehaviorSubject<Famiglia>;
  constructor(private account: AccountService, private store: StoreService, private servizioMenu: ServizioMenuService,
    private http: HttpClient) {
    this.currentCategory$ = new BehaviorSubject<string>(null);
    this.currentCategoryChanged$ = new BehaviorSubject<Famiglia>(null);

    this.currentCategory$.subscribe(newCategory => {
      if (!newCategory)
        this.currentCategoryChanged$.next(null);
      else {
        this.categorie$.pipe(take(1)).subscribe(r => {
          let idFamiglia = newCategory.split('-')[0];
          let famiglie = r[0];
          let foundObj = famiglie.find(obj => obj.codicefamiglia == idFamiglia);
          this.currentCategoryChanged$.next(foundObj);
        });
      }
    });
  }

  loadCategorie(): void {
  forkJoin([
    this.getClassificazioni(1), 
    this.getClassificazioni(2), 
    this.getClassificazioni(3), 
    this.getClassificazioni(4), 
  ]).pipe(
    take(1),
    catchError(err => {
      console.error('loadCategorie error', err);
      return of([[], [], [], []]);
    })
  ).subscribe((r) => {
    this.categorie$.next(r);     
    this.categorie$.complete();  
  });
}

  departments$ = new AsyncSubject<any>();

  categorie$ = new AsyncSubject<any>();


  getPartialBreadcrumbs(ids): Observable<Link[]> {
    return this.categorie$.pipe(map<any, Link[]>(r => {
      let breadcrumbs = [];
      if (ids.length >= 1) {
        let famiglia = r[0].find(obj => obj.codicefamiglia == ids[0]);
        if (!famiglia)
          return breadcrumbs;
        breadcrumbs.push({
          label: famiglia.descrizione,
          url: '/shop/catalog/' + ids[0]
        });
      }

      if (ids.length >= 2) {
        let sottofamiglia = r[1].find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1]);
        if (!sottofamiglia)
          return breadcrumbs;
        breadcrumbs.push({
          label: sottofamiglia.descrizione,
          url: '/shop/catalog/' + ids[0] + '-' + ids[1]
        })
      }

      if (ids.length >= 3) {
        let gruppo = r[2].find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1] && obj.codicegruppo == ids[2]);
        if (!gruppo)
          return breadcrumbs;
        breadcrumbs.push({
          label: gruppo.descrizione,
          url: '/shop/catalog/' + ids[0] + '-' + ids[1] + '-' + ids[2]
        })
      }

      if (ids.length >= 4) {
        let sottogruppo = r[3].find(obj => obj.codicefamiglia == ids[0] && obj.codicesfamiglia == ids[1] && obj.codicegruppo == ids[2] && obj.codicesgruppo == ids[3]);
        if (!sottogruppo)
          return breadcrumbs;
        breadcrumbs.push({
          label: sottogruppo.descrizione,
          url: '/shop/catalog/' + ids[0] + '-' + ids[1] + '-' + ids[2] + '-' + ids[3]
        })
      }

      return breadcrumbs;
    }));
  }

  getBusinessHeader() {
    return {
      ...this.account.getHeader(),
      'Business': this.store.azienda_nome_univoco
    }
  }

  getClassificazioni(tipo?): Observable<any[]> {
    if (!tipo)
      tipo = 1;
    return this.http.get<Categoria[]>(api_base_url + `Classificazioni/${tipo}/disponibili`,
      {
        headers: {...this.getBusinessHeader(), ...this.store.x_canale}
      });
  }

  getWithIconsForList(ids: string): Observable<any> {
    let getPath = (id) => ids ? ids + '-' + id : id;

    return this.categorie$.pipe(map(([famiglia, sottofamiglia, gruppo, sottogruppo]) => {

      let makeObject = (obj, idProp) => ({
        'id': obj[idProp],
        'descrizione': obj.descrizione,
        'path': getPath(obj[idProp]),
        'icon': scaleImg(obj.img, 100, 100),
      });

      if (!ids) {
        ids = '';
        return famiglia.map(obj => makeObject(obj, 'codicefamiglia'));
      }

      let parts = ids.split('-');

      if (parts.length == 1) {
        return sottofamiglia.filter(obj => obj.codicefamiglia == parts[0]).map(obj => makeObject(obj, 'codicesfamiglia'));
      }

      if (parts.length == 2) {
        return gruppo.filter(obj => obj.codicefamiglia == parts[0] && obj.codicesfamiglia == parts[1]).map(obj => makeObject(obj, 'codicegruppo'));
      }

      if (parts.length == 3) {
        return sottogruppo.filter(obj => obj.codicefamiglia == parts[0] && obj.codicesfamiglia == parts[1] && obj.codicegruppo == parts[2]).map(obj => makeObject(obj, 'codicesgruppo'));
      }

      return [];

    }));
  }



}